import { ICommit } from "@/apps/merchant3/shared-models/ICommit";
import IMerchantState from "@/types/merchant";
import INotice from "@/types/INotice";

const actions = {
  setMerchantState: ({ commit }: ICommit, payload: IMerchantState): void => {
    commit("SET_MERCHANT_STATE", payload);
  },
  resetMerchantState: ({ commit }: ICommit): void => {
    commit("RESET_MERCHANT_STATE");
  },

  setMerchantJwt: ({ commit }: ICommit, payload: string): void => {
    commit("SET_MERCHANT_JWT", payload);
  },

  addNotice: ({ commit }: ICommit, payload: INotice): void => {
    commit("ADD_NOTICE", payload);
  },

  setGeolocationAllowed: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_GEOLOCATION_ALLOWED", payload);
  },

  setGeolocationCheckInProgress: (
    { commit }: ICommit,
    payload: boolean
  ): void => {
    commit("SET_GEOLOCATION_CHECK_IN_PROGRESS", payload);
  },

  setGeolocationCheckDone: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_GEOLOCATION_CHECK_DONE", payload);
  },

  setGeolocationActions: (
    { commit }: ICommit,
    payload: { [key: string]: boolean }
  ): void => {
    commit("SET_GEOLOCATION_ACTIONS", payload);
  },
};

export default actions;
